import { Loader2, User } from "lucide-react";
import { trpc } from "@/lib/trpc";
import type { FileRelatedType } from "@bookdental/schemas";

export function EntityRootList({
  relatedType,
  onOpenEntity,
}: {
  relatedType: FileRelatedType;
  onOpenEntity: (relatedId: string, label: string) => void;
}) {
  const entities = trpc.file.listRelatedEntities.useQuery({ relatedType });

  if (entities.isLoading) {
    return (
      <div className="flex justify-center py-16">
        <Loader2 className="h-6 w-6 animate-spin text-brand-600" />
      </div>
    );
  }

  const rows = (entities.data ?? []) as Array<{ id: string; name: string }>;

  if (rows.length === 0) {
    return (
      <div className="rounded-lg border border-zinc-200 bg-white py-16 text-center dark:border-border dark:bg-card">
        <p className="text-sm font-medium text-zinc-900 dark:text-foreground">Nenhum arquivo por aqui ainda</p>
        <p className="mt-1 text-xs text-zinc-500 dark:text-muted-foreground">
          Assim que um arquivo for relacionado, a entidade aparece nesta lista.
        </p>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5">
      {rows.map((row) => (
        <button
          key={row.id}
          type="button"
          onClick={() => onOpenEntity(row.id, row.name)}
          className="flex flex-col items-center gap-2 rounded-xl border border-zinc-200 bg-white p-4 text-center shadow-sm transition-colors hover:border-brand-300 hover:bg-brand-50/50 dark:border-border dark:bg-card dark:hover:bg-primary/5"
        >
          <User className="h-8 w-8 text-brand-500 dark:text-primary" />
          <span className="w-full truncate text-sm font-medium text-zinc-900 dark:text-foreground">{row.name}</span>
        </button>
      ))}
    </div>
  );
}
